<script>
import VueCharts from "vue-chartjs";
//import {Line} from 'vue-chartjs'
import { setDefaultOptions, loadModules, loadCss } from "esri-loader";
import { config } from "@/config/config.js";

export default {
  name: "LineChart",
  extends: VueCharts.Line,
  mounted() {
    this.$store.state.parameterStripe.downloadChartF = this.downloadChartF;
    this.idobontasMap.set("ann", "éves");
    this.idobontasMap.set("MAM", "tavaszi");
    this.idobontasMap.set("JJA", "nyári");
    this.idobontasMap.set("SON", "őszi");
    this.idobontasMap.set("DJF", "téli");
    this.idobontasMap.set("01", "januári");
    this.idobontasMap.set("02", "februári");
    this.idobontasMap.set("03", "márciusi");
    this.idobontasMap.set("04", "áprilisi");
    this.idobontasMap.set("05", "májusi");
    this.idobontasMap.set("06", "júniusi");
    this.idobontasMap.set("07", "júliusi");
    this.idobontasMap.set("08", "augusztusi");
    this.idobontasMap.set("09", "szeptemberi");
    this.idobontasMap.set("10", "októberi");
    this.idobontasMap.set("11", "novemberi");
    this.idobontasMap.set("12", "decemberi");
    //toBlob.init();

    //this.makeChart();
    /*this.renderChart(
      {
        labels: [
          "1971",
          "1981",
          "1991",
          "2001",
          "2011",
          "2021",
          "2031",
          "2041",
          "2051",
          "2061",
          "2071",
        ],
        datasets: [
          {
            label: "Megfigyelés",
            fill: false,
            lineTension: 0,
            borderColor: "rgb(75, 192, 192)",
            data: [40, 39, 10, 40, 39, 80, 40, 4, 6, 100, 45],
          },
          {
            label: "MIN",
            fill: false,
            lineTension: 0,
            borderColor: "red",
            data: [80, 29, 10, 30, 20, 40, 40, 78, 65, 12, 44],
          },
          {
            label: "Q25",
            fill: false,
            lineTension: 0,
            borderColor: "blue",
            data: [40, 90, 56, null, null, null, null, null, null, null, null],
          },
          {
            label: "MED",
            fill: false,
            lineTension: 0,
            borderColor: "blue",
            data: [40, 90, 56, null, null, null, null, null, null, null, null],
          },
          {
            label: "Q75",
            fill: false,
            lineTension: 0,
            borderColor: "blue",
            data: [40, 90, 56, null, null, null, null, null, null, null, null],
          },
          {
            label: "MAX",
            fill: false,
            lineTension: 0,
            borderColor: "blue",
            data: [40, 90, 56, null, null, null, null, null, null, null, null],
          },
        ],
      },
      { responsive: true, maintainAspectRatio: false }
    );*/
  },
  methods: {
    downloadChartF() {
      /*let canvas = this.$refs.canvas;
      canvas.toBlob( blob =>{
        saveAs(blob,'grafikon_lementes.png');
      });*/
      if (!this.$data._chart) return;
      var image = this.$data._chart.toBase64Image();
      var a = document.createElement("a");
      a.href = image;
      let variable = this.$store.state.parameterStripe.variable_1_notation;
      let idoszak = this.$store.state.parameterStripe.idoszak1;
      let felbontas = this.$store.state.parameterStripe.felbontas;
      let graphName =
        "grafikon_" + variable + "_" + idoszak + "_" + felbontas + ".png";
      a.download = graphName;
      a.click();
    },
    setLineColors() {
      let colorClass = this.chartColorClass;
      if (colorClass == "temperature") {
        this.megfigyelesDataset.borderColor = "rgb(0, 0, 0)";
        this.minDataset.borderColor = "rgb(33, 102, 172)";
        this.q25Dataset.borderColor = "rgb(146, 197, 222)";
        this.medDataset.borderColor = "rgb(127, 127, 127)";
        this.q75Dataset.borderColor = "rgb(244, 165, 130)";
        this.maxDataset.borderColor = "rgb(178, 24, 43)";
      } else if (colorClass == "rain") {
        this.megfigyelesDataset.borderColor = "rgb(0, 0, 0)";
        this.minDataset.borderColor = "rgb(140, 81, 10)";
        this.q25Dataset.borderColor = "rgb(223, 194, 125)";
        this.medDataset.borderColor = "rgb(127, 127, 127)";
        this.q75Dataset.borderColor = "rgb(128, 205, 193)";
        this.maxDataset.borderColor = "rgb(1, 102, 94)";
      } else {
        this.megfigyelesDataset.borderColor = "rgba(0, 0, 0, 0)";
        this.minDataset.borderColor = "rgba(75, 192, 192, 0)";
        this.q25Dataset.borderColor = "rgba(75, 192, 192, 0)";
        this.medDataset.borderColor = "rgba(75, 192, 192, 0)";
        this.q75Dataset.borderColor = "rgba(75, 192, 192, 0)";
        this.maxDataset.borderColor = "rgba(75, 192, 192, 0)";
      }
    },
    getData() {
      var self = this;
      self.megfigyelesDataset.data = [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
      ];
      self.minDataset.data = [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
      ];
      self.q25Dataset.data = [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
      ];
      self.medDataset.data = [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
      ];
      self.q75Dataset.data = [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
      ];
      self.maxDataset.data = [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
      ];
      loadModules(["esri/tasks/query", "esri/tasks/QueryTask"]).then(
        ([Query, QueryTask]) => {
          //Itt kell az adatokat letölteni
          var queryTask = new QueryTask(
            config.data_table.url + "/" + config.data_table.table_id,
          );

          queryTask.on("complete", query_complete_handler);
          queryTask.on("error", query_error_handler);
          var query = new Query();
          query.outFields = ["*"];
          query.returnGeometry = false;
          query.orderByFields = ["IDO ASC"];
          //query.where =
          query.where = self.queryString; //"valtozo='ta' and idoszak='ann' and felbontas='HUM000'";

          queryTask.execute(query);

          function query_complete_handler(result) {
            console.log("graph query completed");
            console.log(result);
            var features = result.featureSet.features;
            for (var i = 0; i < features.length; i++) {
              console.log(features[i]);
              self.megfigyelesDataset.data[i] =
                features[i].attributes["MERT_ADAT"];
              self.minDataset.data[i] = features[i].attributes["MIN_"]; //adatbázisban foglalt a min
              self.q25Dataset.data[i] = features[i].attributes["Q25"];
              self.medDataset.data[i] = features[i].attributes["MEDIAN"];
              self.q75Dataset.data[i] = features[i].attributes["Q75"];
              self.maxDataset.data[i] = features[i].attributes["MAX_"]; //adatbázisban foglalt a max
            }
            //console.log(self.megfigyelesDataset.data);
            self.makeChart();
          }
          function query_error_handler(error) {
            console.log(error);
          }
        },
      );
    },
    makeChart() {
      //let graphLabels = this.graphLabels;
      var self = this;
      this.renderChart(
        {
          labels: this.graphLabels,
          datasets: [
            this.megfigyelesDataset,
            this.minDataset,
            //this.q25Dataset,
            this.medDataset,
            //this.q75Dataset,
            this.maxDataset,
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  userCallback: function (item) {
                    return item; //+ " " + self.unit;
                  },
                },
              },
            ],
          },
          title: {
            display: true,
            text: this.graphTitle,
          },
        },
      );
    },
  },
  computed: {
    chartColorClass() {
      return this.$store.state.parameterStripe.variable1_chart_color;
    },
    viewType() {
      return this.$store.state.parameterStripe.viewType;
    },
    queryString: function () {
      let variable = this.$store.state.parameterStripe.variable_1_notation;
      let idoszak = this.$store.state.parameterStripe.idoszak1;
      let felbontas = this.$store.state.parameterStripe.felbontas;
      if (!variable || !idoszak || !felbontas) return "";
      return (
        "valtozo='" +
        variable +
        "' and idoszak='" +
        idoszak +
        "' and felbontas='" +
        felbontas +
        "'"
      );
    },
    unit: function () {
      return this.$store.state.parameterStripe.variable1_unit;
    },
    graphTitle: function () {
      let variableName = this.$store.state.parameterStripe
        .variable1_display_name;
      if (!variableName) return "";
      variableName =
        variableName.charAt(0).toUpperCase() + variableName.slice(1);
      let unit = this.unit;
      let idobontas = this.$store.state.parameterStripe.idoszak1;
      return (
        variableName +
        ", " +
        this.idobontasMap.get(idobontas) +
        " átlag (" +
        unit +
        ")"
      );
    },
  },
  watch: {
    queryString: function () {
      if (!this.queryString) {
        this.$refs.canvas.style.display = "none";
        return;
      }
      this.getData();
    },
    chartColorClass: function () {
      this.setLineColors();
      console.log("grafikon_szin:" + this.chartColorClass);
    },
    viewType: function () {
      if (!this.chartColorClass) {
        console.log("nincs chart color class");
      }
      this.getData();
    },
  },
  data: function () {
    return {
      idobontasMap: new Map(),
      graphLabels: [
        "1971",
        "1976",
        "1981",
        "1986",
        "1991",
        "1996",
        "2001",
        "2006",
        "2011",
        "2016",
        "2021",
        "2026",
        "2031",
        "2036",
        "2041",
        "2046",
        "2051",
        "2056",
        "2061",
        "2066",
        "2071",
      ],
      megfigyelesDataset: {
        label: "Megfigyelés",
        fill: false,
        lineTension: 0,
        borderColor: "rgb(0, 0, 0)",
        data: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      minDataset: {
        label: "MIN",
        fill: false,
        lineTension: 0,
        borderColor: "red",
        data: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      q25Dataset: {
        label: "Q25",
        fill: false,
        lineTension: 0,
        borderColor: "blue",
        data: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      medDataset: {
        label: "MED",
        fill: false,
        lineTension: 0,
        borderColor: "yellow",
        data: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      q75Dataset: {
        label: "Q75",
        fill: false,
        lineTension: 0,
        borderColor: "black",
        data: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      maxDataset: {
        label: "MAX",
        fill: false,
        lineTension: 0,
        borderColor: "green",
        data: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
    };
  },
};
</script>

<style scoped></style>
